import { journalIssueService } from 'src/_services/client/journal_issue.service'
import {
  buildIssuesOrderFilters,
  FILTER_SCHEMA,
  ITEMS_PER_PAGE,
  SORT_OPTIONS,
  SORT_QUERY_VALUES,
  TAB_QUERY_VALUES,
  TABS,
} from './journalIssuesListConfig'

const parseNumberVolumeFilter = (value) => {
  if (!value || typeof value !== 'string') return null
  const trimmed = value.trim()
  if (!trimmed) return null
  const [type, id] = trimmed.split(':')
  if (!type || !id) return null
  return { type, id }
}

export const createJournalIssuesListDefinition = ({ journalUuid }) => ({
  perPage: ITEMS_PER_PAGE,
  sortOptions: SORT_OPTIONS,
  sortParamValues: SORT_QUERY_VALUES,
  tabs: TABS,
  tabParamValues: TAB_QUERY_VALUES,
  filterSchema: FILTER_SCHEMA,
  fetcher: ({ journalUuid, page, perPage, filters }) =>
    journalIssueService.getIssuesPageByJournalUuid(journalUuid, page, perPage, filters),
  selectResults: (data) => ({
    items: data?.['hydra:member'] || [],
    totalItems: data?.['hydra:totalItems'] || 0,
  }),
  buildParams: ({ activeTab, page, perPage, sortValue, textValues, singleValues, booleanValues }) => {
    const [, order] = (sortValue || SORT_OPTIONS[0].value).split('-')
    const filters = buildIssuesOrderFilters(order)

    if (activeTab === 'archived') {
      filters.isArchived = true
    } else if (activeTab === 'latest') {
      filters.isArchived = false
    }

    const numberVolume = parseNumberVolumeFilter(singleValues?.numberVolume)
    if (numberVolume?.type === 'volume' && numberVolume?.id) {
      filters['iri[parent]'] = `/api/open/journal_volumes/${numberVolume.id}`
    }
    if (numberVolume?.type === 'issue' && numberVolume?.id) {
      filters.uuid = numberVolume.id
    }

    if (textValues?.doi) {
      filters.doi = textValues.doi
    }
    if (singleValues?.releaseYearFrom) {
      filters['releaseYear[gte]'] = singleValues.releaseYearFrom
    }
    if (singleValues?.releaseYearTo) {
      filters['releaseYear[lte]'] = singleValues.releaseYearTo
    }
    if (booleanValues?.special) {
      filters.special = true
    }

    return {
      journalUuid,
      page,
      perPage,
      filters,
    }
  },
})
